<template>
  <div>
    <section class="newsList">
      <div v-for="block in renderList" :key="block.key">
        <div v-if="block.renderType === 'mala'" class="main">
          <div class="jingxuan">
            <div class="titles">
              <svg
                t="1637114280460"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="13925"
                width="15"
                height="15"
              >
                <path
                  d="M754.272 433.696 497.92 689.92C489.184 698.912 476.864 704 463.968 704 451.04 704 438.72 698.912 429.984 689.92L269.728 529.792C251.424 510.432 251.424 481.184 269.728 461.824 278.144 453.472 289.664 448.544 301.856 448.128 315.36 447.52 328.48 452.512 337.728 461.824L463.968 588 686.304 365.792C695.168 356.992 707.456 352 720.288 352 733.152 352 745.408 356.992 754.272 365.792 772.576 385.12 772.576 414.368 754.272 433.696M895.872 0 128.128 0C57.248 0 0 57.376 0 128.16L0 895.872C0 966.752 57.376 1024 128.128 1024L895.872 1024C966.752 1024 1024 966.656 1024 895.872L1024 128.16C1024 57.248 966.624 0 895.872 0"
                  p-id="13926"
                  fill="#d41901"
                ></path>
              </svg>
              麻辣热议
            </div>
            <div class="topNew">
              <div v-swiper:mySwiper="swiperOptions">
                <div class="swiper-wrapper">
                  <a
                    :href="i.url"
                    target="_blank"
                    class="swiper-slide"
                    v-for="(i, idx) in malaList"
                    :key="idx"
                  >
                    <div class="item">
                      <div class="contents">
                        <div class="subject">
                          {{ i.title }}
                        </div>
                        <div class="simple-desc">
                          {{ i.summary }}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            showBanner &&
            block.item.isFullwidthTop === 1 &&
            block.item.fullwidthTopUrl
          "
          class="news"
        >
          <div class="news-item bannerImg" @click="goView(block.item)">
            <div class="right-content">
              <div class="subject">{{ block.item.title }}</div>
              <div class="thumb">
                <van-image
                  :src="block.item.fullwidthTopUrl"
                  fit="cover"
                  width="100%"
                  style="aspect-ratio: 2/1"
                >
                  <template #error>
                    <div class="image-placeholder">
                      <van-icon name="photo-o" size="36" color="#ccc" />
                      <span>暂无图片</span>
                    </div>
                  </template>
                </van-image>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="news">
          <div class="news-item" @click="goView(block.item)">
            <div class="right-content">
              <div class="subject">
                {{ block.item.title }}
              </div>
              <div
                v-if="
                  block.item.publishedDate ||
                  block.item.type === 2 ||
                  block.item.type === 3 ||
                  block.item.type === 5
                "
                class="info"
              >
                <van-tag v-if="block.item.type === 2" type="primary">
                  <i
                    class="iconfont icon-zhuanti"
                    style="margin-right: 3px"
                  ></i>
                  专题
                </van-tag>
                <van-tag v-else-if="block.item.type === 3" type="primary">
                  <i class="iconfont icon-bofang" style="margin-right: 3px"></i>
                  直播
                </van-tag>
                <van-tag v-else-if="block.item.type === 5" type="primary">
                  <i
                    class="iconfont icon-lianjie"
                    style="margin-right: 3px"
                  ></i>
                  外链
                </van-tag>
                <span v-if="block.item.publishedDate" class="createformat">{{
                  formatTimeAgo(block.item.publishedDate)
                }}</span>
              </div>
            </div>
            <div v-if="block.item.thumbnail" class="thumb">
              <van-image :src="block.item.thumbnail"></van-image>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

export default {
  props: {
    newList: {
      type: Array,
      default: () => [],
    },
    malaList: {
      type: Array,
      default: () => [],
    },
    showMalaList: {
      type: Boolean,
      default: false,
    },
    showBanner: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: "",
    },
    topicInfo: {
      type: Object,
      default: null,
    },
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      loading: false,
      swiperOptions: {
        slidesPerView: "auto",
        loop: true,
        observeParents: true,
        spaceBetween: 10,
        paginationClickable: true,
        mousewheelControl: true,
        showMalaList: false,
      },
    };
  },
  computed: {
    renderList() {
      const blocks = [];
      const list = this.newList || [];
      const shouldShowMala =
        this.showMalaList && this.malaList && this.malaList.length > 0;

      list.forEach((item, index) => {
        if (index === 19 && shouldShowMala) {
          blocks.push({
            renderType: "mala",
            key: "mala-block",
          });
        }

        blocks.push({
          renderType: item.type === 2 ? "topic" : "normal",
          key: item.id != null ? `news-${item.id}` : `news-${index}`,
          item,
        });
      });
      // console.log(blocks);
      return blocks;
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    // old
    // goView(id, t) {
    //   if (t == 1 || t == 3) {
    //     this.$router.push({name: "news", params: {id: id}});
    //   } else if (t == 4) {
    //     this.$router.push({name: "live", params: {id: id}});
    //   } else if (t == 2) {
    //     this.$router.push({name: "topic", params: {id: id}});
    //   } else {
    //     this.$router.push({name: "news", params: {id: id}});
    //   }
    // },
    formatTimeAgo(time) {
      if (!time) return "";
      const date = new Date(String(time));
      if (Number.isNaN(date.getTime())) return "";

      const now = new Date();
      const sameYear = now.getFullYear() === date.getFullYear();
      const sameMonth = sameYear && now.getMonth() === date.getMonth();
      const sameDay = sameMonth && now.getDate() === date.getDate();

      if (sameDay) {
        const diffMs = Math.max(now.getTime() - date.getTime(), 0);
        const hours = Math.floor(diffMs / (60 * 60 * 1000));
        return `${Math.max(hours, 1)}小时前`;
      }

      if (sameMonth) {
        const startOfNow = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
        ).getTime();
        const startOfDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        ).getTime();
        const days = Math.max(
          Math.floor((startOfNow - startOfDate) / (24 * 60 * 60 * 1000)),
          1,
        );
        return `${days}天前`;
      }

      if (sameYear) {
        const months = Math.max(now.getMonth() - date.getMonth(), 1);
        return `${months}月前`;
      }

      return `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日`;
    },
    // 从专题页进入文章时，把专题 ID 放进路由参数供详情页展示专题面包屑
    newsRouteParams(id) {
      const params = { id: id };
      if (this.from === "topic" && this.topicInfo && this.topicInfo.id != null) {
        params.topicid = this.topicInfo.id;
      }
      return params;
    },
    goView(item) {
      const { id, type: t, externalLink } = item;
      if (t === 5) {
        if (externalLink) {
          window.open(externalLink, "_blank", "noopener,noreferrer");
        }
        return;
      }
      if (t === 1) {
        this.$router.push({ name: "news", params: this.newsRouteParams(id) });
      } else if (t === 3) {
        this.$router.push({ name: "live", params: { id: id } });
      } else if (t === 2) {
        this.$router.push({ name: "topic", params: { id: id } });
      } else {
        this.$router.push({ name: "news", params: this.newsRouteParams(id) });
      }
    },
  },
};
</script>

<style scoped lang="less">
.newsList {
  .news {
    padding: 0 15px;
  }

  .swiper-wrapper {
    // margin: 0 !important;
    .swiper-slide {
      // background: #f1f1f1;
      .item {
        margin-bottom: 4px;
        padding-bottom: 10px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        border-top: 1px solid rgba(0, 0, 0, 0.05);
      }
    }
  }

  .labletitle {
    // font-family: caoshu1;
    font-size: 18px;
    color: #323953;
  }

  .info {
    .van-tag {
      margin-right: 8px;
      background: #e72129;
      border-radius: 0;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      padding: 0 6px;
    }
  }
}

.main {
  padding-bottom: 10px;

  .jingxuan {
    .titles {
      // font-family: caoshu;
      font-size: 18px;
      //font-weight: bold;
      color: #e92129;
      padding: 8px 0;
      padding-left: 15px;
    }

    .iconfont {
      color: #e5444b;
    }
  }
}

.topNew {
  .subject {
    font-size: 14px;
    font-weight: bold;
    color: #323953;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 10px;
    overflow: hidden;
    min-height: 1rem;
  }

  .contents {
    padding: 7px 15px;
  }

  .simple-desc {
    font-size: 14px;
    color: #999;
    //padding: 5px 15px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  img {
    object-fit: cover;
  }
}

.my-swipe {
  padding: 10px 10px 0 10px;
  width: calc(100% - 20px);
  overflow: hidden;
}

.my-swipe .thumb {
  position: relative;
  height: 200px;
  width: calc(100% - 20px);
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0;
    background-color: transparent;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(#000)
    );
    background: -webkit-linear-gradient(top, transparent, #000);
    background: -moz-linear-gradient(top, transparent, #000);
    background: -ms-linear-gradient(top, transparent, #000);
    opacity: 0.6;
  }

  .title {
    color: #fff;
    position: absolute;
    bottom: 20px;
    z-index: 1111;
    left: 10px;
    font-size: 18px;
    width: calc(100 - 20px);
  }
}

.cards {
  .thumb {
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .content {
    padding: 15px;

    .subject {
      color: rgb(21 73 154);
      font-size: 18px;
      font-weight: 700;
    }

    .simple-desc {
      margin: 10px 0;
      color: #999;
      font-size: 14px;
    }
  }
}

.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 180px;
  background: #f5f5f5;
  color: #999;
  font-size: 12px;

  span {
    margin-top: 8px;
  }
}
</style>
